(function(algolia) {
  'use strict';
  var rangeSlider = algolia.externals.widgets.rangeSlider;
  var menu = algolia.externals.widgets.menu;
  var refinementList = algolia.externals.widgets.refinementList;
  var hierarchicalMenu = algolia.externals.widgets.hierarchicalMenu;
  var connectRange = instantsearch.connectors.connectRange;
  var connectHierarchicalMenu = instantsearch.connectors.connectHierarchicalMenu;

  const renderRangeSlider = (renderOptions, isFirstRender) => {
    const { start, range, refine, widgetParams } = renderOptions;

    if (isFirstRender) {
      const selectedPrice = document.createElement('li');
      selectedPrice.setAttribute('class', 'ais-RefinementList-item ais-facet--item ais-RefinementList-item--selected price-selected-hidden');
      selectedPrice.innerHTML = `
      <div>
        <label class="ais-RefinementList-label ais-facet--label options_size"> 14 </label>
      </div>
      `
      const container = document.createElement('div');
      container.classList.add('price-slider')

      container.innerHTML = `
      <div class="input-price-number">
        <input type="number" class="min-number-input" type="range" title="min value"/>
        <span class="divider-number"></span>
        <input type="number" class="max-number-input" type="range" title="max value"/>
      </div>
      <div class="input-price-range">
        <input class="min-range-input" step="1" type="range" title="min value"/>
        <input class="max-range-input" step="1" type="range" title="max value"/>
        <svg width="100%" height="24">
          <line x1="4" y1="0" x2="300" y2="0" stroke="#212121" stroke-width="12" stroke-dasharray="1 28"></line>
        </svg>
      </div>
      <span class="min-range-input-label"></span>
      <span class="max-range-input-label"></span>
      `

      const rangeS = container.querySelectorAll('input[type="range"]');
      const numberS = container.querySelectorAll('input[type="number"]');

      rangeS.forEach(function(el) {
        el.onchange = function() {
          var slide1 = parseFloat(rangeS[0].value),
              slide2 = parseFloat(rangeS[1].value);

          console.log('on chnge')

          if (slide1 > slide2) {
            [slide1, slide2] = [slide2, slide1];
          }

          numberS[0].value = slide1;
          numberS[1].value = slide2;
          refine([slide1, slide2]);
        }
      });

      numberS.forEach(function(el) {
        el.onchange = function() {
        var number1 = parseFloat(numberS[0].value),
        number2 = parseFloat(numberS[1].value);

          if (number1 > number2) {
            var tmp = number1;
            numberS[0].value = number2;
            numberS[1].value = tmp;
          }

          rangeS[0].value = number1;
          rangeS[1].value = number2;
          refine([number1, number2]);
        }
      });

      widgetParams.container.appendChild(selectedPrice);
      widgetParams.container.appendChild(container);
      return;
    }

    const selectedFilter = widgetParams.container.querySelector('.ais-RefinementList-item');

    selectedFilter.onclick = function() {
      refine([range.min, range.max]);
    }

    if(start) {
      const startSelectedMin = !Number.isFinite(start[0]) || start[0] == range.min;
      const startSelectedMax = !Number.isFinite(start[1]) || start[1] == range.max;

      if (!startSelectedMin || !startSelectedMax) {
        selectedFilter.classList.remove('price-selected-hidden');

        const label = selectedFilter.querySelector('.ais-RefinementList-label');

        label.innerText = `$${start[0]} - $${start[1]}`;
      } else {
        selectedFilter.classList.add('price-selected-hidden');
      }
    }

    const inputMaxNumber = widgetParams.container.querySelector('.max-number-input');

    inputMaxNumber.min = range.min;
    inputMaxNumber.max = range.max
    inputMaxNumber.value = Number.isFinite(start[1]) ? start[1] : range.max

    const inputMinNumber = widgetParams.container.querySelector('.min-number-input');

    inputMinNumber.min = range.min;
    inputMinNumber.max = range.max;
    inputMinNumber.value = Number.isFinite(start[0]) ? start[0] : '0';

    const inputMax = widgetParams.container.querySelector('.max-range-input');

    inputMax.min = range.min;
    inputMax.max = range.max;
    inputMax.value = Number.isFinite(start[1]) ? start[1] : range.max;

    const inputMin = widgetParams.container.querySelector('.min-range-input');

    inputMin.min = range.min;
    inputMin.max = range.max;
    inputMin.value = Number.isFinite(start[0]) ? start[0] : '0';

    const inputMaxLabel = widgetParams.container.querySelector('.max-range-input-label');

    inputMaxLabel.innerText = '$' + range.max;

    const inputMinLabel = widgetParams.container.querySelector('.min-range-input-label');

    inputMinLabel.innerText = '$0';

    function updateInputs() {
      const minRangeInput = widgetParams.container.querySelector('.min-range-input');
      const maxRangeInput = widgetParams.container.querySelector('.max-range-input');
      const minNumberInput = widgetParams.container.querySelector('.min-number-input');
      const maxNumberInput = widgetParams.container.querySelector('.max-number-input');
      const minLabel = widgetParams.container.querySelector('.min-range-input-label');
      const maxLabel = widgetParams.container.querySelector('.max-range-input-label');

      // Listen to the input event for real-time updates
      minRangeInput.addEventListener('input', function () {
        // Update min-range-input-label and min-number-input in real-time
        const newValue = '$' + minRangeInput.value;
        //minLabel.innerText = newValue;
        minNumberInput.value = minRangeInput.value;
      });

      maxRangeInput.addEventListener('input', function () {
        // Update max-range-input-label and max-number-input in real-time
        const newValue = '$' + maxRangeInput.value;
        //maxLabel.innerText = newValue;
        maxNumberInput.value = maxRangeInput.value;
      });
    }

    updateInputs();
  };


  function nearestMultiple(x, n) {
    return Math.ceil(x / n) * n;
  }

  // Create the custom widget
  const customRangeSlider = connectRange(
    renderRangeSlider
  );


  const renderList = ({ items, createURL }) => `
  <ul>
    ${items
      .map(
        item => `
          <li>
            <a
              href="${createURL(item.value)}"
              data-value="${item.value}"
              style="font-weight: ${item.isRefined ? 'bold' : ''}"
            >
              ${item.label} (${item.count})
            </a>
            ${item.data ? renderList({ items: item.data, createURL }) : ''}
          </li>
        `
      )
      .join('')}
  </ul>
`;

const renderHierarchicalMenu = (renderOptions, isFirstRender) => {
  const {
    items,
    isShowingMore,
    refine,
    toggleShowMore,
    createURL,
    widgetParams,
  } = renderOptions;

  if (isFirstRender) {
    const list = document.createElement('div');
    const button = document.createElement('button');

    button.addEventListener('click', () => {
      toggleShowMore();
    });

    widgetParams.container.appendChild(list);
    widgetParams.container.appendChild(button);
  }

  const children = renderList({ items, createURL });

  widgetParams.container.querySelector('div').innerHTML = children;
  widgetParams.container.querySelector('button').textContent = isShowingMore
    ? 'Show less'
    : 'Show more';

  [...widgetParams.container.querySelectorAll('a')].forEach(element => {
    element.addEventListener('click', event => {
      event.preventDefault();
      refine(event.target.dataset.value);
    });
  });
};

  // Create the custom widget
  const customHierarchicalMenu = connectHierarchicalMenu(
    renderHierarchicalMenu
  );

  var TYPES_TO_WIDGET = {
    slider: { name: 'rangeSlider', useDefault: false, widget: customRangeSlider  ,params:{pips: true, tooltips:true} },
    hierarchicalMenu:{ name:'hierarchicalMenu', widget: customHierarchicalMenu, params: {sortBy: ['name:asc']} },
    menu: { name: 'menu', params: { limit: 200 }, widget: menu },
    conjunctive: {
      name: 'refinementList',
      params: { operator: 'and', limit: 200},
      widget: refinementList,
    },
    disjunctive: {
      name: 'refinementList',
      params: { operator: 'or', limit: 200 },
      widget: refinementList,
    },
  };



  var sortByRefined = function sortByRefined(sortFunction) {
    return function(a, b) {
      if (a.refined !== b.refined) {
        if (a.refined) {
          return -1;
        }
        if (b.refined) {
          return 1;
        }
      }
      return sortFunction(a, b);
    };
  };

  /*
   * Sorting functions : Allows to chose in which order you want to display the facets
   * Algolia will always send you back the most relevant values for each facet (the ones
   * with the highest count). These sorting functions won't change which results come back
   * but how they are displayed. To retrieve more results, change the maxValuesPerFacet
   * parameter in your Algolia Dashboard.
   * The default sort function is refined > count > name.
   */
  // algolia.facetSortFunctions = {
  //   price_range: sortByRefined(function sortRanges(a, b) {

  //     if (a.name.length === b.name.length) {
  //       return a.name.localeCompare(b.name);
  //     }
  //     return a.name.length - b.name.length;
  //   }),
  // };
  algolia.facetSortFunctions = {
    price_range: sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name);
    }),
  };

  /*
   * Display functions
   * When the object sent back for a facet item doesn't match how you would want it to look
   * like, use a function to reformat it how you want.
   */
  algolia.facetDisplayFunctions = {
    price_range: function displayRange(value) {
      var values = value.split(':');

      return values
        .map(e => {
          return algolia.formatMoney(Number(e) * 100).replace(/\.\d+/, '');
        })
        .join(' - ');
    }
  };

  algolia.facetCssClasses = {
    root: 'ais-facet',
    header: 'ais-facet--header',
    body: 'ais-facet--body',
    item: 'ais-facet--item',
    label: 'ais-facet--label',
    checkbox: 'ais-facet--checkbox',
    active: 'ais-facet--active',
    color: 'custom-color-facet-class',
    count: Boolean(algolia.config.show_products) ? 'ais-facet--count-distinct' : 'ais-facet--count',
  };

  var enabledFacets = algolia.config.facets.filter(facet => {
    return facet.enabled || parseInt(facet.enabled, 20);
  });
  algolia.facets = enabledFacets.map(facet => ({
    ...facet,
    escapedName: encodeURIComponent(facet.name),
  }));
  algolia.shownFacets = algolia.facets.filter(facet => {
    return facet.type !== 'hidden';
  });
  algolia.hiddenFacets = algolia.config.facets.filter(facet => {
    return facet.type === 'hidden';
  });

  var facetToWidget = function(facet) {
    var widget = TYPES_TO_WIDGET[facet.type];
    var params = algolia.assign({}, widget.params);
    //console.log("facet type: ", widget)
    params.container =
      "[class~='ais-facet-" + facet.escapedName + "-container']";
    params.attribute = facet.name;
    params.templates = {};
    params.cssClasses = algolia.facetCssClasses;
    params.sortBy = ['name:asc'];

    /**
     * Providing a custom "Show more" template to confirm to the custom
     */
    params.templates.showMoreText = function showMoreText(data, {html}) {
      return algolia.instantSearchShowMore(data, html)
    }

    if (facet.searchable) {
      params.searchable = true;
      params.searchablePlaceholder = 'Search for ' + facet.title;
      params.templates.searchableNoResults = '<div> No matching for ' + facet.title + '</div>';
    }

    params.templates.header = function() {
      return facet.title;
    };

    if (!widget.useDefault) {
      //console.log("facet.name: ", facet.name)
      params.templates.item = (item, {html}) => {


        function getStarReviewFromString(htmlString) {
          const ratingRegex = /<div class="oke-sr-rating"> ([\d.]+) <\/div>/;
          const matches = htmlString.match(ratingRegex);

          if (matches && matches[1]) {
            const rating = matches[1];
            return rating;
          } else {
            return 0;
          }
        }
        // if(facet.name === 'meta.okendo.StarRatingSnippet'){
        //   var star_review = getStarReviewFromString(item.label);
        // }
        // if (star_review === 0){

        // }else{
          return algolia.instantSearchFacetItem(item, html, facet.name)
        //}

      }
    }

    if (algolia.facetSortFunctions[facet.name]) {
      params.sortBy = algolia.facetSortFunctions[facet.name];
    }

    const optionSizeOrder = [
      "XXS",
      "XS",
      "XS/S",
      "S",
      "Small",
      "S/M",
      "M",
      "Medium",
      "M/L",
      "L",
      "Large",
      "L/XL",
      "XL",
      "XXL",
      "N/S",
      "One Siz",
      "OSFA",
      "Pair",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "12",
      "14",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
      "32",
      "33",
      "34",
      "36",
      "37",
      "38",
      "39",
      "40",
      "41",
      "24/32",
      "25/32",
      "26/32",
      "27/32",
      "28/32",
      "29/34",
      "30/34",
    ]

    var displayFunction = algolia.facetDisplayFunctions[facet.name];
    params.transformItems = function(items) {
      if (items.length && optionSizeOrder.includes(items[0].label)) {
        return items.sort((a, b) => optionSizeOrder.indexOf(a.label) - optionSizeOrder.indexOf(b.label)).map(item => ({
          ...item,
          type: facet.type,
          label: displayFunction ? displayFunction(replaceSize(item.value)) : replaceSize(item.value),
        }));
      }

      return items.map(item => ({
        ...item,
        type: facet.type,
        label: displayFunction ? displayFunction(replaceSize(item.value)) : replaceSize(item.value),
      }));
    }

    function replaceSize(label) {
      return label.replace('One Siz', 'One Size');
    }

    // if(widget.name == 'refinementList') {
    //   widget.widget = refinementList({
    //     container: params.container,

    //   })
    // }

    return {
      name: widget.name,
      params: params,
      widget: widget.widget,
    };
  };

  // try to fetch facets for current collection or fallback to collections default
  var collection_facets =
    algolia.current_collection_id &&
    algolia.config.collection_facets &&
    algolia.config.collection_facets[algolia.current_collection_id]
      ? algolia.config.collection_facets[algolia.current_collection_id]
      : algolia.config.collection_facets &&
        algolia.config.collection_facets.default;

  if (collection_facets) {
    var enabledCollectionFacets = collection_facets.filter(facet => {
      return facet.enabled || parseInt(facet.enabled, 20);
    });

    algolia.collectionFacets = enabledCollectionFacets.map(facet => ({
      ...facet,
      escapedName: encodeURIComponent(facet.name)
    }));
    algolia.collectionShownFacets = algolia.collectionFacets.filter(facet => {
      return facet.type !== 'hidden';
    });
    algolia.collectionHiddenFacets = collection_facets.filter(facet => {
      return facet.type === 'hidden';
    });
    algolia.collectionFacetsWidgets = algolia.collectionShownFacets.map(facetToWidget);
  }
  algolia.facetsWidgets = algolia.shownFacets.map(facetToWidget);


})(window.algoliaShopify);
